// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectedImg_root__1kbUd","deleteBtn":"SelectedImg_deleteBtn__2zubS","img":"SelectedImg_img__MFtrx"};